import React from 'react';
import "../../styling/components/common/Modal.css";

var ConfirmModal = function ConfirmModal(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "contacts-modal-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content"
  }, props.children));
};

export default ConfirmModal;